"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBSearchEmptyResult;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function SVBSearchEmptyResult(props) {
  const {
    searchParam,
    browseText,
    browseLink
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "svb-search-empty-results"
  }, /*#__PURE__*/_react.default.createElement("p", null, "Did you mean:", /*#__PURE__*/_react.default.createElement("span", {
    className: "ps-1 search-parm"
  }, searchParam)), /*#__PURE__*/_react.default.createElement("div", {
    className: "no-result-text text-center"
  }, /*#__PURE__*/_react.default.createElement("p", null, "Sorry, no results match your search."), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: browseLink ? browseLink : "/apis/docs-home"
  }, browseText ? browseText : 'Browse through the API Documentation  intstead.')));
}
SVBSearchEmptyResult.propTypes = {
  searchParam: _propTypes.default.string,
  browseText: _propTypes.default.string,
  browseLink: _propTypes.default.string
};